import React, { useContext } from "react";

import { PrivateContext } from "lib/context";
import { storageHelper } from "lib/helpers";
import { SkeletonAnnotated } from "lib/components";
import constant from "lib/constant/constant";
import { ProviderShippingBand } from "./provider/features";
import { OperatorShipping } from "./operator/features";

const { userKey } = constant;
const { operator, provider } = userKey;

const Shipping = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (role === operator) {
      return <OperatorShipping />;
    }
    if (role === provider) {
      return <ProviderShippingBand />;
    }
    return null;
  };

  if (isLoading) {
    return <SkeletonAnnotated />;
  }

  const currentUserRole = storageHelper.get("userRole");
  const ShippingComponent = getComponent(currentUserRole);
  return ShippingComponent;
};

export default Shipping;
